module.exports = __webpack_public_path__ + "static/img/4002.f100bae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/components/4002.png
// module id = 709
// module chunks = 0 1 12